import { useMemo } from 'react';
import { matchPath, useLocation } from 'react-router-dom';

const useRailRouteMatches = () => {
  const { pathname } = useLocation();

  const is1003Match = !!matchPath(
    '/:lenderDatabaseId/:loanRecordId/summary/:category?',
    pathname,
  );

  const isKnowYourLoanMatch = !!matchPath(
    '/:lenderDatabaseId/:loanRecordId/know-your-loan/:category?',
    pathname,
  );

  const isBaseRouteMatch = !!matchPath(
    '/:lenderDatabaseId/:loanRecordId/:slug?',
    pathname,
  );

  const isAuditHistoryMatch = !!matchPath(
    '/:lenderDatabaseId/:loanRecordId/audit-history/*',
    pathname,
  );

  const isAusHistoryMatch = !!matchPath(
    '/:lenderDatabaseId/:loanRecordId/aus/*',
    pathname,
  );

  const isIncomeWorksheetMatch = !!matchPath(
    '/:lenderDatabaseId/:loanRecordId/income-worksheet',
    pathname,
  );

  const isBOLTRouteMatch =
    isBaseRouteMatch &&
    !is1003Match &&
    !isKnowYourLoanMatch &&
    !isAuditHistoryMatch &&
    !isAusHistoryMatch &&
    !isIncomeWorksheetMatch;

  const showRailNav = is1003Match || isKnowYourLoanMatch || isBOLTRouteMatch;

  return useMemo(
    () => ({
      showRailNav,
      isBOLTRouteMatch,
      is1003Match,
      isKnowYourLoanMatch,
    }),
    [showRailNav, isBOLTRouteMatch, is1003Match, isKnowYourLoanMatch],
  );
};

export default useRailRouteMatches;
